import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { usePagamentoHorasOutletContext } from 'pages/PagamentoHoras'
import { Navigate } from 'react-router-dom'
import { pagamentoHoras } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function PagarTudo() {
    const empresaId = useStore(state => state.companyId)
    const { competencia, selecionados } = usePagamentoHorasOutletContext()
    const { mutateAsync, isLoading } = pagamentoHoras.tudo.mutations.useCreate({
        queryParams: {
            empresaId,
            competencia,
        },
        onSuccess: () => {
            pagamentoHoras.invalidateQueries()
            toast.success('Pagamento realizado com sucesso')
        },
        onError: e => {
            toast.error(e.message)
        },
    })

    if (!selecionados?.length)
        return <Navigate to="/manutencao-ponto/pagamento-horas" />

    const handleSubmit = () => {
        return mutateAsync(selecionados as number[])
    }

    return (
        <Dialog.Root
            height="auto"
            width="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['update', 'PagamentoDeHoras'])}
        >
            <Dialog.Title>
                Pagar {selecionados?.length} funcionário(s)
            </Dialog.Title>
            <Dialog.Content>
                Tem certeza que deseja pagar todas as horas extras e descontar
                as faltas dos funcionários selecionados?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Confirmar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
